@if (canDelete()) {
  <ng-container class="board-list--more-menu">
    <icon-triggered-context-menu [menuItemsFactory]="menuItems" />
  </ng-container>
}
